import { types as t } from 'mobx-state-tree';

import { ImageInfo } from './Script/abtract-script.store';

const PageModel = t.model('Page', {
  templateTypeId: t.maybeNull<any>(t.string),
  status: t.maybeNull<any>(t.string),
  url: t.maybeNull<any>(t.string),
});
export const Test = t.model('Test', {
  createdAt: t.maybeNull<any>(t.string),
  id: t.maybeNull<any>(t.string),
  testID: t.maybeNull<any>(t.string),
  lastModifiedAt: t.maybeNull<any>(t.string),
  coverImage: t.maybeNull(ImageInfo),
  name: t.maybeNull<any>(t.string),
  skill: t.maybeNull<any>(t.string),
  totalDuration: t.maybeNull(t.number),
  totalDurationInSeconds: t.maybeNull(t.number),
  totalSections: t.maybeNull(t.number),
  pages: t.maybe(t.array(PageModel)),
});
